<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="title"
    :on-close="handleClose"
    :on-primary="handleAccept"
    :primary-available="isExportFormValid"
    :primary-button-tooltip="
      !isExportFormValid ? 'A selection is required to export.' : ''
    "
    :width="width"
    class="asc-export-dialog"
  >
    <template v-if="showDialog">
      <div class="asc-export-dialog--content">
        <h1 v-if="header">{{ header }}</h1>
        <v-form ref="exportForm" v-model="valid">
          <template v-if="exportType === 'mxrec'">
            <asc-export-mx-rec
              v-if="items"
              :items="items"
              :data="data"
              @input="handleInput"
            ></asc-export-mx-rec>
          </template>
        </v-form>
      </div>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscExportMxRec from './AscExportMxRec'

export default {
  name: 'AscExportDialog',

  components: {
    AscDialog,
    AscExportMxRec,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 592,
    },
    header: {
      type: String,
      default: undefined,
    },
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    exportType: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    inputData: null,
    valid: false,
  }),

  computed: {
    isExportFormValid() {
      return this.valid
    },
  },

  methods: {
    handleInput(data) {
      this.inputData = data
    },
    handleAccept() {
      this.onAccept(this.inputData)
      this.handleClose()
    },
  },
}
</script>

<style lang="scss">
.asc-export-dialog {
  .asc-export-dialog--content {
    padding-top: 16px;

    & > h1 {
      color: $primary-black;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: normal;
    }
  }
}
</style>
